// src/pages/NewProjectPage.jsx
//
// Dedicated /projects/new route (Jerome's call over an inline form). Posts
// straight to POST /api/tracker/projects/, which on the backend
// (ProjectViewSet.perform_create) also auto-provisions the project's five
// satellite stage rows -- so as soon as this redirects to the detail page,
// Fieldwork/Site_Data/Final_Report/Digital_data/Artifact_submission cards
// already exist and are ready to claim. Permit is the one stage NOT
// auto-created (0-or-1 relationship), so its card starts in a "no permit
// yet" state -- see StageCard.jsx.

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiFetch } from "../api/client";
import Navbar from "../components/Navbar";

export default function NewProjectPage() {
  const [projectTypes, setProjectTypes] = useState([]);
  const [form, setForm] = useState({
    project_no: "",
    project_name: "",
    proponent_name: "",
    project_type: "",
    award_date: "",
  });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    apiFetch("/tracker/project-types/")
      .then(setProjectTypes)
      .catch(() => setProjectTypes([]));
  }, []);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      const payload = {
        project_no: form.project_no,
        project_name: form.project_name || null,
        proponent_name: form.proponent_name || null,
        project_type: form.project_type || null,
        award_date: form.award_date || null,
      };
      const project = await apiFetch("/tracker/projects/", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      navigate(`/projects/${project.id}`);
    } catch (err) {
      setError(err.message || "Couldn't create project.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Navbar />
      <main className="page page-narrow">
        <h1>New project</h1>
        <form onSubmit={handleSubmit} className="stacked-form">
          <div>
            <label>Project #</label>
            <input
              type="text"
              value={form.project_no}
              onChange={handleChange("project_no")}
              required
            />
          </div>
          <div>
            <label>Name</label>
            <input
              type="text"
              value={form.project_name}
              onChange={handleChange("project_name")}
            />
          </div>
          <div>
            <label>Proponent</label>
            <input
              type="text"
              value={form.proponent_name}
              onChange={handleChange("proponent_name")}
            />
          </div>
          <div>
            <label>Type</label>
            <select value={form.project_type} onChange={handleChange("project_type")}>
              <option value="">--</option>
              {projectTypes.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.code}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>Award date</label>
            <input
              type="date"
              value={form.award_date}
              onChange={handleChange("award_date")}
            />
          </div>
          {error && <p className="form-error">{error}</p>}
          <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={submitting}>
              {submitting ? "Creating..." : "Create project"}
            </button>
          </div>
        </form>
      </main>
    </>
  );
}
